import { get, post, put, del } from '../util/http';
import { ENDPOINTS } from '../util/endpoints';

export const roomTypeService = {
  search:  (params)       => get(ENDPOINTS.roomTypes.search, { params }),
  create:  (data)         => post(ENDPOINTS.roomTypes.list, data),
  update:  (id, data)     => put(ENDPOINTS.roomTypes.byId(id), data),
  remove:  (id)           => del(ENDPOINTS.roomTypes.byId(id)),
};
